"use client";

import React from "react";
import PopoverPositionContext from "./context";

function usePopoverPosition() {
  const context = React.useContext(PopoverPositionContext);

  if (!context) {
    throw new Error(
      "usePopoverPosition must be used inside of PopoverPositionProvider",
    );
  }

  return context;
}

export default usePopoverPosition;
